import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';

import 'video.js/dist/video-js.css'

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(VueI18n);

localStorage.setItem('lang','zh_cn')
let lang = 'zh_cn';

const i18n = new VueI18n({
  globalInjection: true, 
  locale: lang, // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
	'yn_yu': require('./assets/languages/yn_yu.json'),
    'zh_cn': require('./assets/languages/zh_cn.json'),
    'en_us': require('./assets/languages/en_us.json'),
    'es_spa': require('./assets/languages/es_spa.json'),
    'ms_my': require('./assets/languages/ms_my.json'),
	'idn_yu': require('./assets/languages/idn_yu.json'),
  'ko_hy': require('./assets/languages/ko_hy.json'),
  'la_yu': require('./assets/languages/la_yu.json'),
	
  }
});


import ElementUI from 'element-ui' //element-ui的全部组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
Vue.use(ElementUI) //使用elementUI



new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
